import { z } from 'zod';
import { t } from 'i18next';
import { InputRegexMap, OnboardingFormFields } from '@Types/types.ts';
import { ControlledTextInput } from '@Components/inputs/ControlledInputs.tsx';
const MIN_NAME_CHARS = 2;
const MAX_NAME_CHARS = 30;
interface IProps {
  disabled?: boolean;
  tabIndex: number;
}
export const getLastNameScheme = () =>
  z.object({
    [OnboardingFormFields.LAST_NAME]: z
      .string()
      .trim()
      .min(1, t('enErrors:required'))
      .min(MIN_NAME_CHARS, t('enErrors:personalDetails.lastNameMinChars'))
      .max(MAX_NAME_CHARS, t('enErrors:lastNameTooLong'))
      .regex(InputRegexMap.lastName, t('enErrors:personalDetails.lastNameNonLetters')),
  });
export const LastNameInput = ({ disabled = false, tabIndex }: IProps) => {
  return (
    <ControlledTextInput
      data-testid='last-name-input'
      name={OnboardingFormFields.LAST_NAME}
      title={t('pages.home.lastName')}
      id={OnboardingFormFields.LAST_NAME}
      disabled={disabled}
      tabindex={tabIndex}
      isPublic={false}
    />
  );
};
